module.exports = __webpack_public_path__ + "static/media/flow.85652c63.jpg";